<template lang='pug'>
 .overlay
   label
    | Overlay Darkness:
   el-slider(
     :min=0
     :max=100
     v-model='overlay'
     @change='on_overlay_changed'
   )
</template>
<script>
  export default {
    name: 'overlay',
    props: {
      landing_page_widget: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        overlay: this.landing_page_widget.draft_content.overlay
      }
    },
    methods: {
      on_overlay_changed(overlay) {
        this.overlay = overlay
        const widget = {...this.landing_page_widget}
        widget.draft_content.overlay = overlay
        this.$emit('input', widget)
      }
    }
  }
</script>

<style>
  .overlay {
    margin-bottom: 10px;
  }
</style>
